export const apiConst = {
    //auth
    verify2fa: "auth/verify2fa",
    resend2fa: "auth/resend2fa",
    twofalogin: "auth/twofalogin",
    twofaregister: "auth/twofaregister",
    complete2falogin: "auth/complete2falogin",
    postlogin: "auth/login",
    postforgotpassword: "auth/forgotpassword",
    postresetpassword: "auth/resetpassword",
    postcheckresetpassword: "auth/checkresetpassword",
    patientSignup: "auth/register",
    getauthprofile: "auth/getauthprofile",
    authlogout: "auth/logout",
    authcookies: "auth/getauthcookies",
    getResource: "auth/getuserresource",
    validateAccount: "auth/validateactivation/",
    activateAccount: "auth/activateaccount",
    exitAuth: "auth/exitauth",
    getSitekey: "auth/getcaptchasitekey",
    verifyCaptcha: "auth/verifycaptcha",
    verifyUserIdentity: "auth/verifyuseridentity",
    accessCode: "auth/accesscode",

    //ALLERGY

    allergyList: "dcallergy/list",
    patientAllergyList: "dcallergy/patientallergy/",
    patientAllergySave: "dcallergy/save",

    //basicAccount

    gethost: "basicaccount/gethostinfo",
    getPortalContent: "basicaccount/getportalcontent",

    //calender

    getmodes: "calender/getcateogry/",

    //contact

    createcontact: "contact/create",
    locationautocomplete: "contact/autocomplete",
    googleAutoComplete: "contact/googleautocomplete",
    updatecontact: "contact/update/",
    getPlaceDetails: "contact/placedetails",

    //Content
    getContent: "dccontent/get/",

    //Condition
    symptomsList: "dccondition/getsymptomlist",
    symptomConditions: "dccondition/symptoms/",

    //customforms
    getformlist: "customform/getforminput/",
    formsave: "customform/create",
    formUpdate: "customform/update/",
    formsList: "customform/getforms/",
    getMultipleForms: "customform/getmultipleforms/",
    getEncounterNoteList: "customform/getencounternotelist/",
    preconsultationrequest: "customform/preconsultationrequest",

    //AnemoCheck
    anemocheckGetAssessmentContext: "anemocheck/getassessmentcontext/",
    anemocheckSubmitAssessment: "anemocheck/submitassessment",

    //Doc
    docViewer: "doc/getviewerurl/",
    docupload: "doc/upload",
    docuploadchunk: "doc/uploadchunk",
    doclist: "doc/doclist/",
    docupdate: "doc/update",
    doccopy: "doc/copy",
    docdelete: "doc/delete",
    getcateogry: "category/get/",
    docdownload: "doc/getdoc",
    docstatus: "doc/docstatus/",
    getActiveSession: "doc/session/",
    getExternalIdentitySession: "doc/getsessions/",
    externalIdentityStatus: "doc/status/",

    //DRUGd

    medicationRequest: "dcdrug/medicationRequest/",

    //DISCOUNT

    validateDiscountCode: "dcdiscount/validatediscount/",
    getDiscount: "dcdiscount/discount",
    getDiscountList: "dcdiscount/list",

    //Note

    getNotes: "dcnote/get/",
    createNotes: "dcnote/createNotes",
    updateNotes: "dcnote/updateNotes",
    //encounter

    getencounter: "encounter/getencounter/",
    encounterList: "encounter/encounterlist/",
    patientencounterList: "encounter/patientencounterlist",
    getencounternote: "encounter/getencounternote/",
    getencounterrule: "encounter/getrule/",
    encountercreate: "encounter/create",
    encounterpharmacy: "encounter/updatepharmacy/",
    changepharmacy: "encounter/changepharmacy/",
    encountertemplate: "encounter/gettemplate",
    encounterModuleAssignment: "encounter/moduleassignment/",
    encounterShipmentCreate: "encounter/encountershipmentcreate",
    encounterShipmentUpdate: "encounter/encountershipmentupdate/",
    encounterShipmentGet: "encounter/encountershipmentget",
    vehicleExemptionGet: "encounter/vehicleexemptionget/",
    vehicleExemptionSave: "encounter/vehicleexemptionsave/",
    getEncounterDetails: "encounter/getencounterdetails/",
    saveEncounterIntakeState: "encounter/saveintakestate",
    getencounterdiagnostic: "encounter/getencounterdiagnostic/",

    //insurance

    getinsurance: "dcinsurance/list",
    addinsurance: "dcinsurance/create",
    updateinsurance: "dcinsurance/update/",
    autocompleteinsurance: "dcinsurance/autocomplete/",
    editinsurance: "dcinsurance/get/",
    verifyInsuranceCoverage: "dcinsurance/verifycoverage/",
    createEncounterInsurance: "dcencounterinsurance/create",
    updateEncounterInsuranceConsent: "dcencounterinsurance/updateconsent/",
    getEncounterInsurance: "dcencounterinsurance/get",
    //LangResources

    getlangresource: "langresource/getlangresource",

    //Message

    getMessage: "dcmessage/get",
    getEncounterMessage: "dcmessage/getencountermesage",
    getMessageList: "dcmessage/get/",
    saveMessage: "dcmessage/create",
    getUnreadMessageCount: "dcmessage/getUnreadMessageCount",
    markAsRead: "dcmessage/markAsRead",

    //MEDICINE

    medicineAutocomplete: "dcdrug/drugautocomplete",
    medicineSave: "rx/createmedication",
    //medicineList: 'rx/getprescriptiondetails',
    medicineList: "dccurrentmedication/getpatientmedication/",
    medicineDelete: "rx/deletemedicaton/",

    //Provider

    getProviderList: "dcprovider/search",
    getProviderProfile: "dcprovider/getprofile",
    gettimeslot: "dcprovider/gettimeslot",
    getlicenseregion: "dcprovider/getlicenseregion",
    getproviderspeciality: "dcprovider/getspeciality",
    getAvailableProvider: "dcprovider/getavailableprovider",
    getNotAssignedMember: "dcprovider/notasssignedmember",
    providerRequest: "dcprovider/providerappointmentrequest/",
    validateUserTimeSlot: "dcprovider/validatetimeslot",

    //patient

    patientinfo: "patient/getinfo",
    getmemberinfo: "patient/getmemberinfo/",
    updateResiding: "patient/updtaeResiding",
    familymembersave: "patient/familymembersave",
    familyMemberUpdate: "patient/familymemberupdate/",
    familymemberget: "patient/familymemberget/",
    getNotificationLog: "patient/getnotificationlog/",
    patientInvite: "patient/patientinvite/",
    patientDeleteRequest: "patient/deleterequest",
    getplatformrequestlog: "patient/getplatformrequestlog/",

    getvital: "patienthealthmetric/vitallist/",
    getvitalform: "patienthealthmetric/gethealthmetrics/",
    getVitalFormGroups: "patienthealthmetric/gethealthmetricsgroup",
    vitalsave: "patienthealthmetric/healthmetricsave/",
    vitalUpdate: "patienthealthmetric/healthmetricupdate/",
    vitalSubmit: "patienthealthmetric/healthmetricsubmit/",
    patienthealthgroupbycode:
        "patienthealthmetric/getpatienthealthmetricbyhealthgroupcode/",
    specialityHealthGroup: "patienthealthmetric/specialityhealthgroup",

    //Pharamacy

    pharamacyautocomplete: "dcpharmacy/cityautocomplete",
    pharamacysearch: "dcpharmacy/pharmacysearch/",
    pharamacypreferences: "dcpharmacy/pharmacypreferences/",
    preferencelist: "dcpharmacy/preferencelist/",
    getPharmacy: "dcpharmacy/pharmacy/",
    getrecommenedpharmacy: "dcpharmacy/recommenedpharmacy",

    //Payment

    proceespayment: "dcpayment/getpayment/",
    proceesenrollpayment: "dcpayment/getenrollpayment/",
    paymentTransaction: "dcpayment/gettransaction",
    paymentlist: "dcpayment/getlist",
    getPrice: "dcpayment/getprice",
    process: "dcpayment/process",
    enrollprocess: "dcpayment/enroll-process",
    getpaymentsettings: "dcpayment/getpaymentsettings",
    getpayzlicontext: "dcpayment/get-payzli-context",
    createOder: "dcpayment/create-order",
    createenrollOder: "dcpayment/create-enrollorder",
    createPaypalOrder: "dcpayment/createPaypalOrder",
    updatepayment: "dcpayment/update-payment",
    updatepaymentsetupintent: "dcpayment/update-payment/setup-intent",

    // print

    prescriptionTemplateGet: "rx/prescriptiontemplateget/",
    labTemplateGet: "rx/labtemplateget/",
    radiologyTemplateGet: "rx/radiologytemplateget/",

    //Plan
    getPlan: "dcplan/getplan/",
    getPlanCode: "dcplan/getplancode/",
    getPlanList: "dcplan/getplanlist/",
    planValidate: "dcplan/planvalidate/",
    enrollmentSave: "dcplan/enrollmentsave",
    enrollmentUpdate: "dcplan/enrollmentupdate",
    subscriptionMenbershipList: "dcplan/subscriptionMenbershipList",
    memberPlanOrderList: "dcplan/memberPlanOrderList",
    memberPlanWidget: "dcplan/planwidget/",
    cancelSubscription: "dcplan/cancelSubscription/",
    membershipEligibility: "dcmembership/eligibility/",

    //labTemplateGet: 'rx/labtemplateget/',

    // rxDetailPage

    consultationdetail: "rx/detaillist/",
    labdetail: "rx/labdetaillist/",
    raddetail: "rx/raddetaillist/",
    prescriptionList: "rx/detaillist/",
    aproveConsent: "rx/updateconsent",

    //Setting

    getresponsecode: "setting/getresponsecode",
    getaccountsettings: "setting/getaccountsetting",
    getAnalyticsConfig: "setting/getanalyticsconfig",
    getGtmPartner: "setting/getgtmpartner",
    getsettingoptions: "setting/getsettingoptions",
    getaccounttimezonelist: "setting/getaccounttimezonelist",
    getsettingvalues: "setting/getsettingvalues/",
    autocompletereason: "setting/autocompletereason",
    getreason: "setting/getreason",
    getSpecialityreason: "setting/specialityreason/",
    getaccountregionalentity: "setting/getaccountresidingstate/",
    getAccountModules: "setting/getaccountmodules/",
    getAccountCountry: "setting/getaccountcountry",
    getPartnerSettings: "setting/getpartnersettings/",
    getAccountPartners: "setting/accountpartners/",
    getClientAccountBootstrap: "setting/getclientaccountbootstrap",
    getResourceBootstrap: "basicaccount/resourcebootstrap",

    //schedule

    getschedulelist: "schedule/getappointmentwidget",
    scheduleconfirmation: "schedule/scheduleconfirm/",
    scheduleupdate: "schedule/updateconfirm",
    discard: "schedule/discard/",
    pendingApointment: "schedule/getpendingappointment",
    getAppointmentRequest: "schedule/getappointmentrequest",
    getFollowUpParent: "schedule/getfollowupparent/",
    checkprotocol: "schedule/checkprotocol/",
    protocoleligibility: "schedule/protocoleligibility",
    getpatientschedule: "schedule/getappointment/",
    updateSchedule: "schedule/updateschedule/",
    updateschedulestatus: "schedule/updateschedulestatus",
    getfrommemberschedule: "schedule/getfrommemberschedule/",

    //speciality

    getAccountspeciality: "dcspeciality/list",
    getSpecialityServiceOption: "dcspeciality/specialityservice/",
    getSpecialitydrug: "dcspeciality/specialitydrug/",

    //Schedule

    schedulecreate: "schedule/create",
    schedulesummary: "schedule/getsummary/",
    scheduleMedicationRequset: "schedule/getsummary/",
    syncintake: "schedule/syncintake/",

    //SERVICE
    getServiceType: "dcservice/servicetype",
    serviceWorkFlowSteps: "dcservice/serviceworkflow",
    serviceSpeciality: "dcservice/servicespeciality/",
    getService: "dcservice/service",

    //user
    getuserprofile: "user/getprofile",
    getProfile: "user/profile",
    getContact: "user/getcontact/",
    getcontactinfo: "user/getcontactinfo",
    getemergencycontact: "user/getemergencycontact",
    updateprofile: "user/updateprofile",
    updateprofilephoto: "user/updateprofilephoto",
    deleteprofilephoto: "user/deleteprofilephoto",
    changepassword: "user/changepassword",
    userupdate: "user/update",
    userpreference: "user/updatepreference",
    userSendOtp: "user/sendpasswordotp",
    checkMember: "user/checkmember/",
    checkAccess: "user/checkaccess/",
    getmemberlanguages: "user/getmemberlanguages",
    getEffectiveContact: "user/geteffectivecontact/",
    //Country
    getCountryList: "country/getlist",
    //Externalorder
    updategroup: "extappointment/updategroup",
    extapptValidate: "extappointment/validate",
    extCaptureData: "extappointment/capturedata",
    extRefIdValidate: "extappointment/validaterefid",
    appointmentRequestInitiate: "extappointment/appointmentrequestinitiate",
    appointmentRequestProcess: "extappointment/appointmentrequestprocess",
    getGroup: "dcgroup/list",
    validateGroup: "dcgroup/validate",
    verifyMember: "dcgroup/verifymember",
    activateMember: "dcgroup/activatemember",
    getGroupPlans: "dcgroup/getgroupplanlist",

    //Medication
    patientMedicationList: "dccurrentmedication/getpatientmedication/",

    //Refill Medication
    dosespotmedicineAutocomplete: "dcrefillmedication/dosespotdrugautocomplete",
    refillMedicationList: "dcrefillmedication/getrefillmedication/",
    refillmedicationSave: "dcrefillmedication/createrefillmedication",
    deleterefillmedicaton: "dcrefillmedication/deleterefillmedicaton/",
    getspecialityprotocol: "dcspeciality/getprotocolinfo",
    getlaborder: "rx/getlaborderlist",
    labsearch: "rx/labsearch",
    getlabfacility: "laborder/getlabfacility",
    getlabresidingstates: "laborder/getresidingstates",
    checkLabResidingEligibility: "laborder/checkresidingstateeligibility",
    createlaborder: "laborder/create",
    createlaborderdraft: "laborder/create/draft",
    submitlaborder: "laborder/submit",
    laborderstatus: "laborder/status",
    getlaborderpricing: "laborder/pricing",
    getlabpaymenttoken: "laborder/getlabpaymenttoken",
    laborderdownloadpdf: "laborder/laborderdownloadpdf",
    labresultdownload: "laborder/labResultdownload",
    // Session
    sessionjoin: "dcsession/join",
    getSessionconfig: "dcsession/getSessionConfig",
    sessionroominfo: "dcsession/roominfo",
    sessionlogsave: "dcsession/log/save",
    sessionlogupdate: "dcsession/log/update",
    sessionend: "dcsession/end",
    locationdetail: "contact/locationdetail",
};

// Staged rollout switch for the schedule/syncintake reconcile on a Reason re-submit.
export const CP_INTAKE_STATE_SYNC_ENABLED = true;

export const appConst = {
    clientCodes: {
        gayaWellness: "GWL",
    },
    encStatusId: {
        initiated: 7,
        requested: 6,
        encounterInitated: 5,
        scheduled: 1,
        cancelled: 4,
    },
    resourceCodes: {
        sharedCalender: "RW8",
        consultNowWithoutProvider: "GT6",
        consultLaterWithProvider: "SD3",
        consultNowWithProvider: "UMS",
    },
    resource: {
        menu: 1,
        moduleMenu: 3,
        publicResource: 4,
    },
    recordType: {
        schedule: 6,
        encounter: 7,
        patientLevel: 4,
        refillMedication: 85,
    },
    typeid: {
        accountstatetypeid: -1,
    },
    areaId: {
        intakeForms: 3,
        encounterLevel: 2,
        patientLevelForms: 4,
        directForms: 6,
        preConsultationForms: 8,
        intakeDisclosures: 9,
        healthInformation: 10,
    },
    cateogries: {
        documents: "doc_type",
        proofUpload: "identification_type",
        relationship: "relationship_type",
        medicaldoc_type: "medicaldoc_type",
        vehicledoc_type: "vehicledoc_type",
        condition: "clinicaldoc_type",
        gender_type: "gender_type",
        //relationship: "relationship_type",
    },
    fileTypes: {
        reason: {
            displayText: ["PNG", "JPEG", "JPG", "GIF", "PDF"],
            validationTypes: [
                "image/png",
                "image/jpeg",
                "image/jpg",
                "image/gif",
                "application/pdf",
            ],
        },
        reasonCapture: {
            displayText: ["PNG", "JPEG", "JPG"],
            validationTypes: ["image/png", "image/jpeg", "image/jpg"],
        },
        profile: {
            displayText: ["PNG", "JPEG", "JPG", "GIF", "PDF"],
            validationTypes: [
                "image/png",
                "image/jpeg",
                "image/jpg",
                "image/gif",
                "application/pdf",
            ],
        },
        encounter: {
            displayText: [
                "PDF",
                "DOC",
                "DOCX",
                "XLS",
                "XLSX",
                "JPEG",
                "JPG",
                "PNG",
                "GIF",
            ],
            validationTypes: [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "image/jpeg",
                "image/png",
                "image/gif",
            ],
        },
        refillMedication: {
            displayText: ["PNG", "JPEG", "JPG"],
            validationTypes: ["image/png", "image/jpeg", "image/jpg"],
        },
    },
    preferedPharmacy: {
        system: "TEM",
        patient: "TIE",
        pharmacyElectronic: "ELC",
        pharmacyEmail: "PHY",
        pharmacyPatient: "PPC",
        preferredMedication: "MRE",
    },
    encounterModes: {
        online: "TEL",
        inPerson: "INP",
        phone: "PHN",
        phoneOnline: "PHT",
        textMessage: "TMG",
    },
    encounterModeId: {
        TEL: "2",
        INP: "1",
        PHN: "3",
        PHT: "4",
        TMG: "5",
    },
    calendarWeeks: {
        OWT: 1,
        TWT: 2,
        HWT: 3,
        FWT: 4,
    },
    recordTypeid: {
        memberInsurance: 70,
        encounterInsurance: 107,
        patient: 5,
        message: 30,
        member: 4,
        encounter: 7,
        schedule: 6,
        labRx: 9,
        membershipEnrollment: 54,
    },
    consultNotes: {
        EB6: {
            typeId: 1,
        },
        NS8: {
            typeId: 3,
        },
        AP2: {
            typeId: 4,
        },
        SY3: {
            typeId: 5,
        },
        IQ8: {
            typeId: 6,
        },
        RV4: {
            typeId: 7,
        },
        ZI7: {
            typeId: 8,
        },
    },
    nonAdult: {
        nonAdultAge: 18,
    },
    // Maximum accepted patient age — the earliest allowed DOB is a rolling
    // "today − maximumAge years" bound, never a fixed year (a fixed 1900-style
    // cutoff goes stale over time).
    maximumAge: 125,
    veriffStatus: {
        created: 1, // Session created locally
        inProgress: 2, // started / submitted
        approved: 3, // approved / verified
        declined: 4, // declined
        resubmission: 5, // resubmission_requested
    },
    extPlatformSource: {
        wordPress: 2
    },
    extActions: {
        create_appt: "create_appt",
        session_expired: "session_expired",
        dashboard: "dashboard",
        message: "message",
    },
    encounterMethodId: {
        consultLaterWithProvider: 1,
        sharedCalender: 2,
        consultNowWithoutProvider: 3,
        consultNowWithProvider: 4,
    },
};

export const resourceConst = {
    actions: {
        view: "VW",
        create: "CR",
        edit: "ED",
        print: "PNT",
        delete: "DEL",
        download: "DWNLD",
    },
};

export const apptMethodConst = {
    types: {
        GT6: 1058, // Consult now without Provider
        RW8: 1052, // Consult Later without Provider
        SD3: 1057, // Consult Later with Provider
        UMS: 1103, // Consult Now with Provider
    },
};
